import { Config, ISearchUser } from "../../store/types/userTypes";
import { IDataAction } from "./types/dataTypes";

export const saveUser = (user: any): IDataAction<any> => {
  return {
    type: "SAVE_USER",
    payload: user,
  };
};

export const saveAuthorization = (authorization: any): IDataAction<any> => {
  return {
    type: "SAVE_AUTHORIZATION",
    payload: authorization,
  };
};

export const dataSetLoading = (value: boolean): IDataAction<any> => {
  return {
    type: "DATA_LOADING",
    payload: value,
  };
};

export const dataSetLoaded = (value: boolean): IDataAction<any> => {
  return {
    type: "DATA_LOADED",
    payload: value,
  };
};

export const dataSetSearch = (value: ISearchUser): IDataAction<any> => {
  return {
    type: "DATA_SEARCH",
    payload: value,
  };
};

export const dataSetConfig = (value: Config): IDataAction<any> => {
  return {
    type: "DATA_CONFIG",
    payload: value,
  };
};

export const setFindCompanion = (userCompanion: any): IDataAction<any> => {
  return {
    type: "DATA_SET_FIND_COMPANION",
    payload: userCompanion,
  };
};

export const dataReset = (): IDataAction<any> => {
  return {
    type: "RESET",
  };
};

export const isLoadingUserData = (value: boolean): IDataAction<any> => {
    return {
        type: "IS_LOADING_USER_DATA",
        payload: value,
    };
}
